import React from 'react'; // Removed useState, useEffect as carousel is gone
import AnimatedTitle from '../AnimatedTitle/AnimatedTitle';
import '../../App.css';
import './HomePage.css'; // Styles moved/updated
import ProjectsSection from '../Projects/ProjectsSection';
// It's good practice to define image paths here or pass them as props
const HERO_BACKGROUND_IMAGE_URL = 'ee_hero_background.png'; // Replace with your actual path in /public
const HEADSHOT_IMAGE_URL = 'austinadam.jpeg'; 



export default function HomePage() {
  return (
    <>
      {/* Hero Section */}
      <section 
        className="hero-section text-white text-center flex flex-col justify-center items-center" 
        style={{ backgroundImage: `url(${HERO_BACKGROUND_IMAGE_URL})` }}
      >
        <div className="hero-overlay bg-black bg-opacity-50 absolute inset-0"></div> {/* Overlay for text readability */}
        <div className="relative z-10 container mx-auto px-4 py-20 md:py-32">
          <img 
            src={HEADSHOT_IMAGE_URL} 
            alt="Austin Adam - Electrical Engineer" 
            className="hero-headshot w-40 h-40 md:w-48 md:h-48 rounded-full mx-auto mb-8 border-4 border-white shadow-lg"
          />
          <div className="max-w-2xl mx-auto">
             {/* AnimatedTitle already has text color, but if it needs override for hero: */}
            <div className="mb-6">
                <AnimatedTitle />
            </div>
            <p className="text-lg md:text-xl mb-8 font-light">
              Innovative Electrical Engineer with 5+ years in Semiconductor Industry 
            </p>
            <a 
              href="#about-content" 
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-md text-lg transition-colors duration-300 transform hover:scale-105 inline-block"
            >
              Learn More About Me
            </a>
          </div>
        </div>
      </section>

      {/* Content Section (Previously your 2-column layout) */}
      <section id="about-content" className="py-16 bg-transparent">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-gray-800 dark:text-gray-100 mb-10">About Me</h2>
          <div className="bg-white dark:bg-[#0b1220] dark:text-slate-200 border border-slate-200 dark:border-[#1e3a8a] p-8 rounded-xl shadow-xl space-y-6">
            <p className="text-gray-700 leading-relaxed text-lg text-justify">
              Thanks for visiting my website! As an Electrical Engineer, I thrive on the challenge of solving complex problems and 
              continuously expanding my knowledge in the ever-evolving tech landscape. 
              From conceptualizing intricate circuit designs to bringing hardware to life, 
              my passion lies in the tangible impact of electrical engineering.
            </p>
            <p className="text-gray-700 leading-relaxed text-lg text-justify">
              My journey has equipped me with a strong foundation in hardware integration and system debugging 
              and hands-on experience with semiconductor process tools and industry standards.
              I am always eager to explore new technologies and contribute to innovative projects.
            </p>
            <p className="text-gray-700 leading-relaxed text-lg text-justify">
              Feel free to explore my portfolio to see some of the projects I've worked on. 
              I'm always open to discussing new opportunities, collaborations, 
              or just chatting about exciting developments in electrical engineering!
            </p>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-10 bg-transparent">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl font-semibold mb-4">Projects</h2>
          <ProjectsSection />
        </div>
      </section>
    </>
  );
}
